import { AutogenLayoutStateAdditionalTaxesTable } from "./autogen/AutogenLayoutStateAdditionalTaxesTable";
import {
    ClickEvent, DataSourceMode, DataSourceModeChangeEvent, EditRowDecorator, Layout, LookupModelSearchEvent,
    LookupModelSelectionEvent, TableRow
} from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { StateAddAdditionalTaxes } from "./StateAddAdditionalTaxes";
import { CommonTooltips } from "@mcleod/common";

export class StateAdditionalTaxesTable extends AutogenLayoutStateAdditionalTaxesTable {
    public taxTableBeforeLookupSearch: (event: LookupModelSearchEvent) => string;
    onLoad(): void | Promise<void> {
        this.mainDataSource.addAfterModeChangeListener((event: DataSourceModeChangeEvent) => {
            this.buttonAddAdditionalTaxes.visible = event.newMode !== DataSourceMode.SEARCH;
        });
        this.tableAdditionalTaxes.onEditLayoutLoaded = this.configureEditLayout();
        this.buttonAddAdditionalTaxes.addClickListener(async () => {
            const startingData = await this.tableAdditionalTaxes._createNewRowData();
            const layout = Layout.getLayout(this.tableAdditionalTaxes.addLayout) as StateAddAdditionalTaxes;
            const erd = new EditRowDecorator({
                layout: layout,
                title: "Add Additional Taxes",
                layoutLoadListeners: () => {
                    layout.textboxEmployeeAddtlTable.addBeforeLookupModelSearchListener(this.taxTableBeforeLookupSearch.bind(this));
                    layout.textboxEmployerAddtlTable.addBeforeLookupModelSearchListener(this.taxTableBeforeLookupSearch.bind(this));
                    StateAdditionalTaxesTable.setupTaxTableTooltips(layout);
                },
                overlayProps: { closeOnClickOff: false, greyedBackground: true },
                data: startingData,
                dataSourceMode: DataSourceMode.ADD,
                onDelete: null,
                onSave: (updatedData: ModelRow | any) => {
                    this.tableAdditionalTaxes.dataSource.addRow(updatedData, 0);
                }
            });
        });
    }

    TableRowOnDblClick(event: ClickEvent) {
        const tableRow = event.target as TableRow;
        tableRow.showEditLayout();
    }

    configureEditLayout(): (rowDecorator: EditRowDecorator, tableRow: TableRow) => void {
        return async (rowDecorator: EditRowDecorator, tableRow: TableRow) => {
            const layout = rowDecorator.layout as StateAddAdditionalTaxes;
            layout.title = "Edit Additional Taxes";
            layout.addLayoutLoadListener(() => {
                layout.textboxEmployeeAddtlTable.addBeforeLookupModelSearchListener(this.taxTableBeforeLookupSearch.bind(this));
                layout.textboxEmployerAddtlTable.addBeforeLookupModelSearchListener(this.taxTableBeforeLookupSearch.bind(this));
                StateAdditionalTaxesTable.setupTaxTableTooltips(layout, tableRow);
            });

            rowDecorator.onSave = ((updatedData: ModelRow) => {
                tableRow.saveChangesFromEdit(updatedData);
                tableRow.displayComponentValues();
            });
        };
    }

    private static setupTaxTableTooltips(layout: StateAddAdditionalTaxes, tableRow?: TableRow): void {
        // Set up tooltips for auxiliary and miscellaneous fields
        // These will get tooltips from the corresponding tax table fields when they are selected
        const auxiliaryAndMiscComponents = [
            {
                main: layout.textboxEmployeeAddtlTable,
                aux: layout.textboxEmployeeAuxiliary,
                misc: layout.textboxEmployeeMiscellaneous
            },
            {
                main: layout.textboxEmployerAddtlTable,
                aux: layout.textboxEmployerAuxiliary,
                misc: layout.textboxEmployerMiscellaneous
            }
        ];

        auxiliaryAndMiscComponents.forEach(({ main, aux, misc }) => {
            main.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
                const instructions = event.selection?.get("description");
                if (instructions) {
                    // Set the same tooltip for auxiliary and miscellaneous fields
                    main.tooltipDynamicContent = instructions;
                    aux.tooltipDynamicContent = instructions;
                    misc.tooltipDynamicContent = instructions;
                }
            });
            if (tableRow) {
                main.tooltipDynamicContent = tableRow.data.get(main.field + "_instructions")
                aux.tooltipDynamicContent = tableRow.data.get(main.field + "_instructions")
                misc.tooltipDynamicContent = tableRow.data.get(main.field + "_instructions")
            }
        });
    }
}
